import React from "react";
import { Link } from "react-router-dom";
class SliderContent extends React.Component {
  getBuyLink() {
    return "/buy/device/" + this.props.promotion;
  }
  render() {
    return (
      <div className="home-table">
        <div className="home-table-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-white text-right">
                  <div className=" mb-4 mx-auto" />
                  <div style={{ clear: "both", height: "50px" }} />
                  <h1 className="header_title_ab pt-2 mb-0 font-weight-normal mx-auto">
                    {this.props.title}
                  </h1>
                  <div style={{ clear: "both", height: "20px" }} />
                  {/*<strong style={{ fontSize: "1.2em" }}>AS LOW AS</strong>*/}
                  <div style={{ clear: "both" }} />
                  <h1 className="header_title_ab pt-2 mb-0 font-weight-normal mx-auto">
                    ${this.props.promotion}
                  </h1>
                  {/*<h2 className="wherehome-white-ab">
                    connect Up to 5 devices
                    <br />
                    Unlimited Data
                    <br />
                    No Contract
                  </h2>
                  * After data cap per day, speed limited to Maximum of 128kbps.*/}
                  <div style={{ clear: "both", height: "20px" }} />
                  <h2 className="wherehome-white-promo">
                    <mark>Your purchase comes with:</mark>
                  </h2>
                  <h2 className="wherehome-white-promo-item">
                    <ul className="fa-ul">
                      <li><i className="fa fa-check"></i> Personal Wifi hotspot device</li>
                      <li><i className="fa fa-check"></i> Free {this.props.promotion == 159 ? '50' : '3'} GB US data for 30 days {this.props.promotion == 119 ? 'OR' : ''}</li>
                      <li><i className="fa fa-check"></i> Free 3 GB Global Data for 30 days</li>
                    </ul>
                    <Link to={ this.getBuyLink() } className="btn btn-promo-buy mt-4">
                      BUY PROMO
                    </Link>
                  </h2>
                  <div style={{ clear: "both", height: "100px" }} />
                  <div className="header_btn">

                    <Link to="/rent" className="btn btn-custom-rent mt-4">
                      RENT
                    </Link>

                    <Link to="recharge/device" className="btn btn-custom-recharge mt-4">
                      RECHARGE
                    </Link>

                    <Link to="buy/device" className="btn btn-custom-buy mt-4" style={{ background: "#000", border: "#000" }}>
                      BUY
                    </Link>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SliderContent;



// WEBPACK FOOTER //
// ./src/pages/getwifius/SliderContent.js